module.exports = __webpack_public_path__ + "media/blinking_aria.f3dac8d0.mp4";